
/**
 * Helper function to format file size
 * @param size - Size of the file in bytes
 * @returns Formatted file size as a string
 */
export const formatFileSize = (size: number): string => {
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
    return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  };
  